import { useCallback, useRef } from 'react'

import { useCustomerProductTourStatus } from 'hooks/useCustomerProductTourStatus'

export const useNotificationsModalDeps = {
  useCustomerProductTourStatus,
}

export const useNotificationsModal = () => {
  const { useCustomerProductTourStatus } = useNotificationsModalDeps

  const { updateProductTourStatus, showNotificationsWelcome } =
    useCustomerProductTourStatus()

  const hasNotSeenBefore = useRef(showNotificationsWelcome)

  const disableNotificationsModal = useCallback(async () => {
    await updateProductTourStatus({ showNotificationsWelcome: false })
  }, [updateProductTourStatus])

  const shouldShowNotificationsModal =
    hasNotSeenBefore.current === null || Boolean(hasNotSeenBefore.current)

  return {
    disableNotificationsModal,
    shouldShowNotificationsModal,
  }
}
